/**
 * This functional component "Add Media" provides form to add new Media or update existing Media .
 * Created Date:23-April-2024
 */
import "./edit-image-media-form.css";
import { FormattedMessage } from "react-intl";
import { Formik, Field, Form } from "formik";
import { observer } from "mobx-react";
import FormLoader from "../../../../shared-components/FormLoader/FormLoader";
import FormikFormInput from "../../../../shared-components/FormikFormHandlers/FormikFormInput";
import FormikFormTextArea from "../../../../shared-components/FormikFormHandlers/FormikFormTextArea";
import LoaderButton from "../../../../shared-components/button/loader-button";
import Label from "../../../../shared-components/label/label";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useStore } from "../../../../contexts/store-provider";
import {
  AddImageMediaValidateSchema,
  AddMediaFileValidateSchema,
  AddMediaHeightWidthalidateSchema,
  AddMediaPriceValidateSchema,
  AddMediaValidateSchema,
  UpdateImageMediaValidateSchema,
  UpdateImagePricingMediaValidateSchema,
  UploadImageMediaValidateSchema,
} from "../../../../shared-components/FormikFormHandlers/FormikValidationSchema";
import FormikFormImageFileInput from "../../../../shared-components/FormikFormHandlers/FormikFormImageFileInput";
import { IFolderOption } from "../../../../models/ICommon";
import folderCategoryTypeEnum from "../../../../constants/enums/folder-category-type-enum";
import toast from "react-hot-toast";
import { formatMessage } from "../../../../translations/format-message";

interface IProps {
  id: number;
  submitHandler: (data: any) => void;
  selectedFolderType: number;
  allFolders: IFolderOption[];
  onModalClosed: () => void;
  initialValues: any;
  isLoading: boolean;
}

const AddMediaForm = (props: IProps) => {
  const { preferencesStore } = useStore();
  const { getMediaAccess } = preferencesStore;
  const { initialValues, submitHandler, isLoading, onModalClosed } = props;

  const [data, setData] = useState({ ...initialValues });
  // const [showHidePassword, setShowHidePassword] = useState(false);
  const [currentStep, setCurrentStep] = useState<number>(0);

  useEffect(() => {
    setData({ ...initialValues });
  }, [initialValues]);

  const handleNextStep = (newData: any, final: boolean = false) => {
    setData((prev: any) => ({ ...prev, ...newData }));
    if (final) {
      let tempValues: any = { ...newData };
      submitHandler(tempValues);
      return;
    }
    setCurrentStep((prev) => prev + 1);
  };

  const handlePrevStep = (newData: any) => {
    setData((prev: any) => ({ ...prev, ...newData }));
    setCurrentStep((prev) => prev - 1);
  };

  const getFolderCategoryById = (): any => {
    const item = props.allFolders.find(
      (item: any) => item.id === getMediaAccess.folderId
    );
    return item ? item.category : false;
  };

  const StepOne = (props1: any) => {
    const handleSubmit = (values: any) => {
      // if(props.Id > 0){
      //     props.submitHandler(values);
      //     // props1.next(values, props.Id === -1 ? false : true);
      // }else{

      props1.next({ ...values });
      // }
    };
    return (
      <Formik
        initialValues={props1.data}
        onSubmit={handleSubmit}
        validationSchema={
          (props.selectedFolderType == 3 || props.selectedFolderType == 4 || props.selectedFolderType == 5 ) ? AddMediaHeightWidthalidateSchema : props.selectedFolderType == 1 ?
            AddMediaPriceValidateSchema : AddMediaValidateSchema
          // props.selectedFolderType == folderCategoryTypeEnum.PriceImages
          //   ? props.id == -1
          //     ? AddImagePricingMediaValidateSchema
          //     : UpdateImagePricingMediaValidateSchema
          //   : props.id == -1
          //   ? AddImageMediaValidateSchema
          //   : UpdateImageMediaValidateSchema
        }
        validateOnBlur={false}
        enableReinitialize
      >
        {({ values, isValid }) => {
          return (
            <Form id="formBody">
                <div className="modal-body">
              {props.id === -1 && (
                <div className="pt-3">
                  <div className="progress step-progress">
                    <div className="progress-bar" role="progressbar"></div>
                  </div>
                  <div className="step-container d-flex justify-content-between">
                    <div className="step-circle active">
                      1{" "}
                      <span className="step-detail">
                        <FormattedMessage id="media_details" />
                      </span>
                    </div>
                    <div className="step-circle">
                      2{" "}
                      <span className="step-detail">
                        <FormattedMessage id="upload_media" />
                      </span>
                    </div>
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col-md-12 col-12">
                  <div className="form-group formSet">
                    <Label
                      className="label-style"
                      required={true}
                      label="media_name"
                    />
                    <Field
                      data-testid="imageName"
                      className="form-control"
                      name="MediaName"
                      placeholder="media_name"
                      type="text"
                      disabled={props.id > 0 ? true : false}
                      validcharacter={["_"]}
                      invalidcharacter={[" "]}
                      as={FormikFormInput}
                    />
                  </div>
                </div>

                {folderCategoryTypeEnum[getFolderCategoryById()] == "1" && (
                  <div className="col-md-12 col-12">
                    <div className="form-group formSet">
                      <Label
                        className="label-style"
                        required={true}
                        label="pricing_value"
                      />
                      <Field
                        data-testid="pricing_value"
                        className="form-control"
                        name="PricingValue"
                        placeholder="pricing_value"
                        type="text"
                        as={FormikFormInput}
                      />
                    </div>
                  </div>
                )}

                {(props.selectedFolderType == 3 ||
                  props.selectedFolderType == 4 ||
                  props.selectedFolderType == 5) && (
                    <div className="row pe-0">
                                            <div className="col-md-6 col-6">
                        <div className="form-group formSet">
                          <Label
                            className="label-style"
                            required={true}
                            label="media_width"
                          />
                          <Field
                            data-testid="media_height"
                            className="form-control"
                            name="Width"
                            placeholder="media_width"
                            type="number"
                            as={FormikFormInput}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-6">
                        <div className="form-group formSet">
                          <Label
                            className="label-style"
                            required={true}
                            label="media_height"
                          />
                          <Field
                            data-testid="media_height"
                            className="form-control"
                            name="Height"
                            placeholder="media_height"
                            type="number"
                            as={FormikFormInput}
                          />
                        </div>
                      </div>

                    </div>
                  )}

                <div className="col-12">
                  <div className="form-group formSet">
                    <Label
                      className="label-style"
                      required={false}
                      label="comment"
                    />
                    <Field
                      rows={props.id == -1 ? 3 : 2}
                      id="Comment"
                      className="form-control"
                      name="Comment"
                      placeholder="comment"
                      type="text"
                      as={FormikFormTextArea}
                    />
                  </div>
                </div>
              </div>

              <div className="mt-3 d-flex justify-content-center">
                {props.id > 0 ? (
                  <LoaderButton
                    type={isValid ? "submit" : "button"}
                    id="SaveTenant"
                    onClick={
                      isValid
                        ? () => {
                            props1.next(values, true);
                          }
                        : undefined
                    }
                    isLoading={props.isLoading}
                    text="submit"
                    className="ms-2"
                  />
                ) : (
                  <LoaderButton
                    type={"submit"}
                    id="SaveTenant"
                    isLoading={props.isLoading}
                    text="next"
                  />
                )}
                {/* {
                  props.Id > 0 &&
                  <LoaderButton
                    type={isValid ? "submit" : "button"}
                    id="SaveTenant"
                    onClick={isValid ? ()=>{props1.next(values, true);} : undefined}
                    isLoading={props.isLoading}
                    text="Update"
                    className="ml-3"
                  />
                } */}
              </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    );
  };

  const StepTwo = (props2: any) => {
    const [fileData, setFileData] = useState<any>();
    const [base64, setBase64] = useState<any>();
    const [mediaExtension, setMediaExtension] = useState<any>();
    const handleSubmit = (values: any) => {
      if(props.selectedFolderType !== folderCategoryTypeEnum.FixedVideo && mediaExtension == "mp4") {
        toast.error(formatMessage("cannot_add_video"));
      }
      else if(props.selectedFolderType == folderCategoryTypeEnum.FixedVideo && mediaExtension !== "mp4"){
        toast.error(formatMessage("cannot_add_image"));
      }
      else{
        props.submitHandler({
          ...values,
          File: fileData,
          Extension: mediaExtension,
          Base64: base64,
        });
      }

      // props2.next(values, props.Id === -1 ? false : true);
    };
    return (
      <Formik
        initialValues={props2.data}
        onSubmit={handleSubmit}
        validationSchema={AddMediaFileValidateSchema}
        validateOnBlur={false}
        enableReinitialize
      >
        {({ values }) => {
          return (
            <Form id="formBody">
               <div className="modal-body">
              <div className="pt-3">
                <div className="progress px-1 step-progress">
                  <div
                    className={`progress-bar ${
                      props.id === -1 ? "w-50" : "w-100"
                    }`}
                    role="progressbar"
                  ></div>
                </div>
                <div className="step-container d-flex justify-content-between">
                  <div className="step-circle completed">
                    1{" "}
                    <span className="step-detail">
                      <FormattedMessage id="media_details" />
                    </span>
                  </div>
                  <div className="step-circle active">
                    2{" "}
                    <span className="step-detail">
                      <FormattedMessage id="upload_media" />
                    </span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="form-group mb-1">
                    <Label
                      className="label-style"
                      required={true}
                      label="upload_media"
                    />
                    <Field
                      className="form-control"
                      id="upload_media"
                      name="File"
                      setFile={setFileData}
                      setBase64={setBase64}
                      setExtension={setMediaExtension}
                      accept=".jpg, .jpeg, .png, .svg, .mp4, .gif"
                      as={FormikFormImageFileInput}
                    />
                  </div>
                </div>
              </div>
              <div className="pb-3 mt-4 d-flex justify-content-center">
                <Button
                  data-testid="back"
                  variant="light-secondary"
                  onClick={() => {
                    setBase64(undefined);
                    setFileData(undefined);
                    props2.prev({...values, File: ""});
                  }}
                  disabled={props.isLoading}
                  className="mr-3"
                >
                  <FormattedMessage id="back" />
                </Button>

                <LoaderButton
                  type="submit"
                  id="SaveTenant"
                  className="ms-2"
                  isLoading={props.isLoading}
                  text="submit"
                />
              </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    );
  };

  const steps = [
    <StepOne
      next={handleNextStep}
      data={data}
      Id={props.id}
      isLoading={isLoading}
    />,
    <StepTwo
      next={handleNextStep}
      prev={handlePrevStep}
      data={data}
      Id={props.id}
      isLoading={isLoading}
    />,
  ];

  return (
    <div>
      {isLoading && <FormLoader loading={isLoading} />}
      {steps[currentStep]}
    </div>
  );
};
export default observer(AddMediaForm);
